var _g, _defs, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColorMale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 14,
    r: 12,
    fill: "var(--color-grey-400)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 14,
    r: 12,
    fill: "url(#b)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "b",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2101_56352",
    transform: "translate(-.155) scale(.00032)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2101_56352"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_2101_56352",
    result: "effect2_dropShadow_2101_56352"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow_2101_56352",
    result: "effect3_dropShadow_2101_56352"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect3_dropShadow_2101_56352",
    result: "shape"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.0553 0 0 .05668 6.258 5.243)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.671 253.512c-11.151-37.754-67.121-33.566-91.279-44.408-24.157-10.842-20.386-47.219-23.449-53.548H130.01c-3.058 6.329.714 42.711-23.449 53.548-24.157 10.842-80.133 6.655-91.279 44.408-6.149 20.824-5.857 27.193-7.554 50.26 0 0 76.8 15.187 150.014 15.187 73.214 0 153.488-15.187 153.488-15.187-1.703-23.073-1.41-29.435-7.559-50.26z",
    fill: "#f26d49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.671 253.512c-11.151-37.754-67.121-33.566-91.279-44.408-24.157-10.842-20.386-47.219-23.449-53.548h-31.206s-.719 51.024 23.438 61.866c24.157 10.842 80.133 6.655 91.279 44.408 5.857 19.83 5.868 26.552 7.324 47.073 19.234-2.816 31.442-5.126 31.442-5.126-1.693-23.078-1.4-29.44-7.549-50.265z",
    fill: "#eb5f24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.795 205.512l-1.225 26.057a61.671 61.671 0 0013.849 3.625 61.057 61.057 0 0014.186-3.788l-2.484-25.889h-24.326z",
    fill: "#dbb491"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.418 211.285a60.855 60.855 0 0011.972-2.956l-.27-2.816h-24.326l-.118 2.563a61.567 61.567 0 0012.742 3.209z",
    fill: "#c69e7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.155 207.401l-33.05 28.715-4.985-30.604zm-99.923.337l33.582 28.378 3.981-30.604z",
    fill: "#eb5f24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.795 205.512l-25.72-13.984s-3.389 4.817-11.843 16.21l31.723 22.853 2.704-14.923zm24.325 0l25.72-13.984s3.861 4.48 12.315 15.873l-32.195 23.191-2.704-14.923z",
    fill: "#e0dbd3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.84 191.528l-25.72 13.984 1.776 5.772c2.372 2.602 5.109 4.716 8.279 6.138 2.799 1.253 6.02 2.31 9.555 3.249l18.419-13.265c-8.447-11.398-12.309-15.878-12.309-15.878z",
    fill: "#d3cec7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.619 312.062c27.631 3.552 62.771 6.897 97.124 6.897 35.112 0 71.854-3.496 100.581-7.133v-22.853s-56.852 8.526-100.721 8.526c-43.869 0-96.978-8.526-96.978-8.526v23.089z",
    fill: "#eb5f24"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(100.195 228.52 118.55)",
    cx: 228.519,
    cy: 118.551,
    rx: 21.386,
    ry: 11.629,
    fill: "#cca483"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(169.801 90.263 118.559)",
    cx: 90.262,
    cy: 118.558,
    rx: 11.629,
    ry: 21.386,
    fill: "#dbb491"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.64 47.359H95.231s-35.989 146.614 64.187 160.806C259.633 193.973 223.64 47.359 223.64 47.359z",
    fill: "#dbb491"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.418 208.165c100.216-14.192 64.221-160.806 64.221-160.806h-15.024c4.114 61.242 9.808 93.774-13.815 129.24-18.717 28.104-35.382 31.566-35.382 31.566z",
    fill: "#cca483"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.561 43.498L86.839 53.817v30.447s3.417 2.366 6.216 3.232c0 0 34.19 7.655 57.735-1.343 21.049-8.043 30.346-32.611 51.361-32.931 3.58-.056 6.694.669 9.403 1.956z",
    fill: "#cca483"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.786 48.725C230.064 25.956 201.191 0 159.48 0S88.897 25.956 83.169 48.725c0 0-10.932 47.483 7.683 67.931 0 0-.916-18.548.956-33.313 0 0 34.19 7.655 57.735-1.343 21.049-8.043 30.346-32.611 51.361-32.931 19.487-.292 25.282 22.387 26.237 34.275.955 11.888.955 33.313.955 33.313 18.621-20.449 7.69-67.932 7.69-67.932z",
    fill: "#3b3b3b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorMale);
export default __webpack_public_path__ + "static/media/color-male.45e854b87fde3f66c887874f5fee4d7a.svg";
export { ForwardRef as ReactComponent };